import { MarkdownText } from '../MarkdownText';
import { jsx as _jsx } from "react/jsx-runtime";
export function TextBlock({
  block
}) {
  const {
    text
  } = block;
  return /*#__PURE__*/_jsx("div", {
    "data-block-type": "text",
    children: /*#__PURE__*/_jsx(MarkdownText, {
      text: text
    })
  });
}